import { render, staticRenderFns } from "./bfb-log-list.vue?vue&type=template&id=00ef2c3c&scoped=true&"
import script from "./bfb-log-list.vue?vue&type=script&lang=js&"
export * from "./bfb-log-list.vue?vue&type=script&lang=js&"
import style0 from "./bfb-log-list.vue?vue&type=style&index=0&id=00ef2c3c&prod&lang=scss&"
import style1 from "./bfb-log-list.vue?vue&type=style&index=1&id=00ef2c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef2c3c",
  null
  
)

export default component.exports